import React, { useEffect, useState } from 'react'

import LoadingState from 'Pods/ThreeDStudio/Shared/LoadingState/LoadingState'

let CommunityGalleryPanel = null
let communityGalleryImportPromise = null

export const importCommunityGalleryPanel = () => {
  if (!communityGalleryImportPromise) {
    communityGalleryImportPromise = import(
      /* webpackChunkName: "community-gallery-panel" */
      'Pods/LazyLoaded/CommunityGalleryPanel/Hosts/Studio/CommunityGalleryPanelContainer'
    ).then((mod) => { CommunityGalleryPanel = mod.default })
  }
  return communityGalleryImportPromise
}

function LazyCommunityGalleryPanel() {
  const [isLoaded, setIsLoaded] = useState(() => !!CommunityGalleryPanel)

  useEffect(() => {
    if (!CommunityGalleryPanel) {
      importCommunityGalleryPanel().then(() => setIsLoaded(true))
    }
  }, [])

  if (!isLoaded || !CommunityGalleryPanel) return <LoadingState />
  return <CommunityGalleryPanel />
}

export default LazyCommunityGalleryPanel
